@use './variables' as *;
@use '../../styles/abstracts/break-points' as *;

@mixin overlay($offset: 0) {
  position: absolute;
  top: $offset;
  right: $offset;
  bottom: $offset;
  left: $offset;
}

%overlay {
  @include overlay;
}

.modal {
  @extend %overlay;
  display: none;
  z-index: $modal-z-index;
  position: fixed;
  flex-direction: $modal-flex-direction;
  justify-content: $modal-flex-justify-position;
  align-items: $modal-flex-align-items;
  overflow: hidden;
  &.is-visible {
    display: flex;
  }
}

.modal-overlay {
  @extend %overlay;
  background-color: $modal-overlay-background-color;
}

.modal-content {
  display: block;
  position: relative;
  width: $modal-content-width;
  max-width: $modal-max-width;
  max-height: $modal-max-height;
  border-radius: $modal-border-radius;
  background-color: $modal-body-background-color;
  box-shadow: $modal-box-shadow;

  @media (max-width: $breakpoint-mobile) {
    max-height: $mobile-modal-max-height;
  }
}

.modal-header {
  padding-top: $modal-header-padding-top;
  padding-right: $modal-header-padding-right;
  padding-bottom: $modal-header-padding-bottom;
  padding-left: $modal-header-padding-left;

  @media (max-width: $breakpoint-mobile) {
    padding-top: $mobile-modal-header-padding-top;
    padding-right: $mobile-modal-header-padding-right;
    padding-bottom: $mobile-modal-header-padding-bottom;
    padding-left: $mobile-modal-header-padding-left;
  }
}

.modal-footer {
  padding-top: $modal-footer-padding-top;
  padding-right: $modal-footer-padding-right;
  padding-bottom: $modal-footer-padding-bottom;
  padding-left: $modal-footer-padding-left;

  @media (max-width: $breakpoint-mobile) {
    padding-top: $mobile-modal-footer-padding-top;
    padding-right: $mobile-modal-footer-padding-right;
    padding-bottom: $mobile-modal-footer-padding-bottom;
    padding-left: $mobile-modal-footer-padding-left;
  }
}

.modal-body {
  padding-top: $modal-padding-top;
  padding-right: $modal-padding-right;
  padding-bottom: $modal-padding-bottom;
  padding-left: $modal-padding-left;

  @media (max-width: $breakpoint-mobile) {
    padding-top: $mobile-modal-padding-top;
    padding-right: $mobile-modal-padding-right;
    padding-bottom: $mobile-modal-padding-bottom;
    padding-left: $mobile-modal-padding-left;
  }
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: $modal-header-box-shadow;
}

.modal-body {
  overflow: auto;
  max-height: $modal-body-max-height;
}

.modal-footer {
  box-shadow: $modal-footer-box-shadow;
}

.modal-close {
  position: relative;
  cursor: pointer;
  width: $modal-close-size;
  height: $modal-close-size;
  margin: $modal-close-margin;
}
